export default __webpack_public_path__ + "static/island-ab5bea6f174f0931b85ff4d75efe889c.png";